import type { Assistant } from "@inrev/assistant";
import type { AssistantMessageId } from "@inrev/common";
import { useMutation } from "@tanstack/react-query";
import { logError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";

export const useCreateAssistantFeedback = () => {
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			messageId,
			...body
		}: Assistant.Dtos.Feedback.Create.Request & { messageId: AssistantMessageId }) =>
			post<Assistant.Dtos.Feedback.Create.Response>(
				`/v2/admin/assistant/messages/${messageId}/feedback`,
				body,
			),
		// The feedback control shows its own error inline, so this skips the global error modal.
		onError: logError,
	});

	return {
		createAssistantFeedback: mutation.mutateAsync,
		createAssistantFeedbackIsLoading: mutation.isPending,
	};
};
